/** Adds ids to draw edges via -keyword-links.json  files instead keywords are anonymized*/
export function slugify(title, used, fallbackIndex) {
  const base =
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || `paper-${fallbackIndex}`;
  return dedupe(base, used);
}

export function extractDoi(doiOrUrl) {
  const match = /doi\.org\/(.+)$/.exec(doiOrUrl || '');
  return match ? match[1] : null;
}

function dedupe(base, used) {
  let slug = base;
  let i = 2;
  while (used.has(slug)) {
    slug = `${base}-${i}`;
    i += 1;
  }
  used.add(slug);
  return slug;
}

export function assignPaperIds(records) {
  const used = new Set();
  return records.map((record, i) => {
    const doi = extractDoi(record.metadata?.doi_or_url);
    const id = doi ? dedupe(doi, used) : slugify(record.metadata?.title || '', used, i);
    return { ...record, _id: id };
  });
}
